<template>
  <div class="spotligth">
    <body class="skew">
      <div v-if="show" :class="[show ? 'isShow' : 'notShow']">
        PortFolio
        
        <div class="subMenu justify-center">

          <div v-for="(nav, index) in nav_list" :key="nav.name">
            <v-col v-if="!index == 0" cols="4" ms="12" xs="12">
              <v-btn dark :height="height" :width="width" text :to="nav.link" class="btn">
                <v-icon class="ma-2" large>{{ nav.icon }}</v-icon>
                {{ nav.name }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-col>
          </div>

        </div>
      </div>
      <div id="fly-in" v-else>
        <transition-group name="movie" appear @after-enter="showMain">
          <div v-for="list in movieLists" :key="list.main">
            <span>{{ list.sub }}</span
            >{{ list.main }}
          </div>
        </transition-group>
      </div>
    </body>
  </div>
</template>

<script>
export default {
  props: ["nav_list"],
  data() {
    return {
      show: false,
      movieLists: [
        { sub: "Welcome to", main: "My PortFolio" },
        { sub: "Created by", main: "Ueda.I" },
      ],
    };
  },
  methods: {
    showMain() {
      this.show = true;
    },
  },
  created() {
    this.show = sessionStorage.getItem("access");
  },
  computed: {
      height () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 100
          case 'sm': return 100
          case 'md': return 150
          case 'lg': return 150
          case 'xl': return 150
          default: return 150
        }
      },
      width () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 300
          case 'sm': return 300
          default: return 200
        }
      },
    },
};
</script>

<style scoped>

body {
  background-color: #111;
  background-image: radial-gradient(#333, #111);
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  text-align: center;
  width: 100vw;
  height: 100vh;
  font-weight: 600;
  overflow: hidden;
}

.notShow {
  opacity: 0;
}

.isShow {
  opacity: 1;
  font-size: 10vw;
  height: 7vh;
  text-transform: uppercase;
  animation: switch2 1.2s linear 1;
  position: relative;
  top: 10%;
}

div > .subMenu {
  display: flex;
}

.btn {
  font-size: min(2vw,28px);
}

@media screen and (max-width: 880px) {
  div > .subMenu {
  display: block;
}
}

#fly-in {
  font-size: 10em;
  margin: 40vh auto;
  height: 7vh;
  text-transform: uppercase;
}

#fly-in span {
  display: block;
  font-size: 0.4em;
  opacity: 0.8;
}

#fly-in div {
  position: fixed;
  margin: 2vh 0;
  opacity: 0;
  left: 10vw;
  width: 80vw;
}

.movie-enter {
  opacity: 0;
}

.movie-enter-active {
  animation: switch 6s linear 1;
}

.movie-enter-to {
  opacity: 0;
}

#fly-in div:nth-child(2) {
  animation-delay: 3s;
}
#fly-in div:nth-child(3) {
  animation-delay: 6s;
}

@keyframes switch {
  0% {
    opacity: 0;
    filter: blur(20px);
    transform: scale(12);
  }
  10% {
    opacity: 1;
    filter: blur(0);
    transform: scale(1);
  }
  20% {
    opacity: 1;
    filter: blur(0);
    transform: scale(0.9);
  }
  30% {
    opacity: 0;
    filter: blur(10px);
    transform: scale(0.1);
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

@keyframes switch2 {
  0% {
    opacity: 0;
    filter: blur(20px);
    transform: scale(12);
  }
  50% {
    opacity: 1;
    filter: blur(10px);
    transform: scale(1);
  }
  100% {
    opacity: 1;
    filter: blur(0);
  }
}
</style>>
